<template>
<div>
    <!-- <p style="font-size:2em;">{{$store.state.qtyreducetitle[$store.state.clct]}}</p> -->
    <p style="font-size:2em;">{{title}}</p>
    <qtychange  :changer="changer" :changee="changee" qtychange="qtyreduce" clctto="_out"></qtychange>
</div>
</template>

<script>
import qtychange from "./qtychange"
export default {
    components:{qtychange},
        data(){
        let actioninobj=this.$store.state.currentheader.find(ele=>{return ele.name==="actionout"})
        let changer=actioninobj.changer||"number"
        let changee=actioninobj.changee||"qty"
        var gotocollection=this.$store.state.collections.find(obj=>{
            return obj.value===this.$store.state.clct+"_out"
        })
        return {
            title:gotocollection?gotocollection.label:"",
            changer:changer,
            changee:changee
        }
    }
    
}
</script>




// WEBPACK FOOTER //
// src/components/qtychange/qtyreduce.vue